/* ../src/components/TokenType.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	space
} from "svelte/internal";

import store from "../store";
import config from "../config";

function create_fragment(ctx) {
	let div1;
	let input0;
	let input0_checked_value;
	let t0;
	let input1;
	let input1_checked_value;
	let t1;
	let input2;
	let input2_checked_value;
	let t2;
	let div0;
	let mounted;
	let dispose;

	return {
		c() {
			div1 = element("div");
			input0 = element("input");
			t0 = space();
			input1 = element("input");
			t1 = space();
			input2 = element("input");
			t2 = space();
			div0 = element("div");
			attr(input0, "type", "radio");
			attr(input0, "name", "token-choice");
			attr(input0, "id", "fa1-2");
			input0.checked = input0_checked_value = /*$store*/ ctx[0].tokenType === "fa12";
			attr(input1, "type", "radio");
			attr(input1, "name", "token-choice");
			attr(input1, "id", "fa2");
			input1.checked = input1_checked_value = /*$store*/ ctx[0].tokenType === "fa2_ft" || /*$store*/ ctx[0].tokenType === "fa2_nft";
			attr(input2, "type", "radio");
			attr(input2, "name", "token-choice");
			attr(input2, "id", "tezzies");
			input2.checked = input2_checked_value = /*$store*/ ctx[0].tokenType === "tezzies";
			attr(div0, "class", "ball");
			attr(div1, "class", "token-choice");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, input0);
			append(div1, t0);
			append(div1, input1);
			append(div1, t1);
			append(div1, input2);
			append(div1, t2);
			append(div1, div0);

			if (!mounted) {
				dispose = [
					listen(input0, "click", /*click_handler*/ ctx[2]),
					listen(input1, "click", /*click_handler_1*/ ctx[3]),
					listen(input2, "click", /*click_handler_2*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$store*/ 1 && input0_checked_value !== (input0_checked_value = /*$store*/ ctx[0].tokenType === "fa12")) {
				input0.checked = input0_checked_value;
			}

			if (dirty & /*$store*/ 1 && input1_checked_value !== (input1_checked_value = /*$store*/ ctx[0].tokenType === "fa2_ft" || /*$store*/ ctx[0].tokenType === "fa2_nft")) {
				input1.checked = input1_checked_value;
			}

			if (dirty & /*$store*/ 1 && input2_checked_value !== (input2_checked_value = /*$store*/ ctx[0].tokenType === "tezzies")) {
				input2.checked = input2_checked_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(0, $store = $$value));

	const updateTokenType = async type => {
		store.updateTokenType(type);
		store.updateUserBalance("--");

		if (type === "fa2_ft") {
			document.getElementById("fungible-token").click();
		}

		// updates token instances if necessary
		if (type === "fa12" && !$store.fa12_instance) {
			// FA1.2
			const contract = await $store.Tezos.wallet.at(config.fa12[$store.network]);

			store.updateFA12_instance(contract);
		} else if (type === "fa2_ft" && !$store.fa2_ft_instance) {
			// FA2
			const contract = await $store.Tezos.wallet.at(config.fa2Address[$store.network]);

			store.updateFA2_ft_instance(contract);
		}

		// updates user's token balance if connected
		if (type === "fa12" && $store.userAddress) {
			// FA1.2
			const storage = await $store.fa12_instance.storage();

			const account = await storage.ledger.get($store.userAddress);

			if (account) {
				store.updateUserBalance(account.balance.toNumber());
			} else {
				store.updateUserBalance(0);
			}
		} else if (type === "fa2_ft" && $store.userAddress) {
			// FA2
			const storage = await $store.fa2_ft_instance.storage();

			const balance = await storage.assets.ledger.get($store.userAddress);

			if (balance) {
				store.updateUserBalance(balance.toNumber());
			} else {
				store.updateUserBalance(0);
			}
		} else if (type === "tezzies" && $store.userAddress) {
			const balance = await $store.Tezos.tz.getBalance($store.userAddress);
			store.updateUserBalance(balance.toNumber() / 1000000);
		}
	};

	const click_handler = () => updateTokenType("fa12");
	const click_handler_1 = () => updateTokenType("fa2_ft");
	const click_handler_2 = () => updateTokenType("tezzies");
	return [$store, updateTokenType, click_handler, click_handler_1, click_handler_2];
}

class TokenType extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default TokenType;